<template>
  <div
    class="panel d2-report-chart-card space-y-6"
    @mouseover="showReport()"
    @mouseout="hideReport()"
  >
    <h5 class="d2-report-chart-title">{{ title }}</h5>
    <Chart
      type="line"
      :data="lineStylesData"
      :options="basicOptions"
    />
    <ChartReport :tableShow="reportShow" :tableData="tableData" :lang="langData" />
  </div>
</template>

<script>

import { ref, computed } from 'vue';
import ChartReport from './ChartReport.vue';

export default {
  name: 'ChartPanel',
  props: {
    title: {
      type: String,
      default: 'xxx'
    },
    chartsData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    tableData: {
      type: Array,
      default: () => []
    },
    lang: {
      type: Object
    }
  },
  components: {
    ChartReport
  },
  setup(props) {
    const reportShow = ref(false);

    const basicOptions = computed(() => ({
      legend: {
        position: 'bottom',
        /* eslint-disable */
        onClick: function(e, legendItem) {
          let index = legendItem.datasetIndex;
          let ci = this.chart;
          let meta = ci.getDatasetMeta(index);

          // See controller.isDatasetVisible comment
          if (legendItem.text !== undefined && legendItem.text !== '優化建議') {
            meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
          }
          // We hid a dataset ... rerender the chart
          ci.update();
        },
        /* eslint-disable */
        labels: {
          filter: function(e) {
            //console.log('e',e);
            return e.text !== undefined;
          }
        }
      },
      tooltips: {
        mode: 'point',
        callbacks: {
          title: function (ctx, data) {
            // console.log('ctx');
            // console.log(ctx);
            // console.log('data');
            // console.log(data);
            if(data.datasets[ctx[0].datasetIndex].fill == true){
              return data.datasets[ctx[0].datasetIndex].data[ctx[0].index].x
            }
          }
        }
        // mode: 'index',
        // // intersect: false,
        // position: 'nearest',
        // // enabled: true,
        // callbacks: {
        //     title: function(tooltipItem, data) {
        //       console.log('title tooltipItem');
        //       console.log(tooltipItem);
        //       console.log('title data');
        //       console.log(data);
        //     },
        //     label: function(tooltipItem, data) {
        //       console.log('label tooltipItem');
        //       console.log(tooltipItem);
        //       console.log('label data');
        //       console.log(data);
        //       return data.datasets[tooltipItem.datasetIndex].label || 'Other';
        //     }
        // }
        // filter: function(e) {
        //   console.log('e',e);
        //   console.log('props',props);
        //   // console.log('props.tableData',props.tableData);
        //   const optimizeDatasetsCounts = props.tableData.length * 2;
        //   // console.log('optimizeDatasetsCounts');
        //   // console.log(optimizeDatasetsCounts);
        //   console.log('props.chartsData.datasets[0].data['+e.index+']');
        //   console.log(props.chartsData.datasets[0].data[e.datasetIndex]);
        //   return e.datasetIndex >= optimizeDatasetsCounts;
        // }
      },
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'day',
            displayFormats: {
              month: 'YYYY/MM/DD'
            }

          }
        }],
        x: {
          ticks: {
            color: '#f02222'
          },
        },
        y: {
          ticks: {
            color: '#f02222'
          },
        }
      }
    }));

    const lineStylesData = computed(() => {

      // console.log('props.chartsData');
      // console.log(props.chartsData);
      if (props.tableData.length <= 0) {
        return props.chartsData;
      } else {
        // 圖畫最大值
        const maxDataArray = [];
        props.chartsData.datasets.map((e) => {
          maxDataArray.push(Math.max(...e.data.map(p => p.y)));
        });
        const maxData = 6 - Math.max(...maxDataArray) % 6 > 0 ? Math.max(...maxDataArray) + 6 - Math.max(...maxDataArray) % 6 : Math.max(...maxDataArray);

        // console.log('Math.max(...maxDataArray) + 6 - Math.max(...maxDataArray) % 6');
        // console.log(Math.max(...maxDataArray) + 6 - Math.max(...maxDataArray) % 6);
        // console.log('Math.max(...maxDataArray)');
        // console.log(Math.max(...maxDataArray));
        // console.log('maxDataArray');
        // console.log(maxDataArray);
        // console.log('maxData');
        // console.log(maxData);

        let optimizeDatasets = [];
        for (let idx = 0; idx < props.tableData.length; idx++) {
          // Since Data
          let sinceItem = {
            data: [
              {
                x: new Date(props.tableData[idx].since),
                y: 0
              },
              {
                x: new Date(props.tableData[idx].since),
                y: maxData
              }
            ],
            pointRadius: 0,
            fill: false,
            borderColor: props.tableData[idx].borderColor,
            pointHoverRadius: 0,
            tension: .4,
            showLine: true
          }

          let untilItem = {
            data: [
              {
                x: new Date(props.tableData[idx].until),
                y: 0
              },
              {
                x: new Date(props.tableData[idx].until),
                y: maxData
              }
            ],
            pointRadius: 0,
            fill: false,
            borderColor: props.tableData[idx].borderColor,
            pointHoverRadius: 0,
            tension: .4,
            showLine: true
          }

          // if (idx === 0) {
          //   sinceItem.label = '優化建議';
          // }
          optimizeDatasets.push(sinceItem);
          optimizeDatasets.push(untilItem);
        }
        let finial = {...props.chartsData};
        finial.datasets = [...optimizeDatasets, ...finial.datasets];
        //console.log('finial');
        //console.log(finial);
        return finial;
        // return props.chartsData;
      }

    });

    const langData = computed(() => {
      return props.lang
    });

    const showReport = () => {
      reportShow.value = true;
    };

    const hideReport = () => {
      reportShow.value = false;
    }

    return {
      reportShow,
      lineStylesData,
      basicOptions,
      showReport,
      hideReport,
      langData
    }
  }
};
</script>

<style lang="css" scoped>

.panel {
  width: 100%;
}

@media (max-width: 1199px) {
  .panel {
    width: 100%;
    height: auto;
  }
}

</style>
